import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-form-table',
  templateUrl: './form-table.component.html',
  styleUrls: ['./form-table.component.scss']
})
export class FormTableComponent implements OnInit {

  @Input() tableArray = [];
  @Input() fieldKey = 'name';
  @Output() deleteitem = new EventEmitter<any>();
  @Input() showDeleted: boolean = false;


  constructor() {
  }

  ngOnInit() {
  }

  onDeleteitem(index) {
    this.deleteitem.emit(index);
  }

}
